<template>
  <!-- 通知公告 -->
  <div class="home-nav">
    <div class="home-top">
      <img src="@assets/home/tzgg.svg" alt class="box-img" />
      <span>通知公告</span>
    </div>

    <a-row class="notice">
      <a-col :span="24" :key="index" v-for="(item, index) in tbList">
        <a-row>
          <a-col :span="20" class="one-line">
            <span class="title">{{ item.title }}</span>
          </a-col>
          <a-col :span="4" class="down-icon">
            <a @click="handleDownLoad(item.filename, item.filepath, index, item.title)">
              <a-icon type="download" />
            </a>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getAction, downFile } from '@/api/manage.js'
import Vue from 'vue'

export default {
  name: 'Notice',
  data() {
    return {
      description: '这是首页——通知公告',
      downAction: `${window._CONFIG['fileSysUrl']}/download/downloadToResponse`,
      tbList: [
        {
          title: '安天e采驱动',
          filename: '安天e采驱动_Setup.exe',
          filepath: 'M00/00/7D/rBAE-1_Iuh6AFDf3AjVGVLZVsBg620.exe'
        },
        {
          title: '投标人操作手册',
          filename: '投标人操作手册.pdf',
          // filepath: 'M00/00/7B/rBAE-1_ISsOALqgOACkqH1W4x40669.pdf',
          filepath: 'M01/38/48/rBAAzWVVvuCAd_kCAJNFyeecDH8837.pdf'
        },
        {
          title: 'CA证书办理手册',
          filename: 'CA证书办理手册.pdf',
          // filepath: 'M00/00/7B/rBAE-1_ISRWAArvSAApmmq5GKeQ70.docx',
          filepath: 'M01/38/48/rBAAzWVVvpCASVIzAAmOVuM6Rrc269.pdf'
        },
        {
          title: '安天e采投标文件制作软件',
          filename: '安天e采投标文件制作软件_Setup.exe',
          filepath: 'M00/00/7D/rBAE-1_IukuAFchUBa19bf-KCqc636.exe'
        }
      ]
    }
  },
  created() {},
  methods: {
    handleDownLoad(attachName, attachPath, index, title) {
      if (title == '安天e采驱动' || title == '安天e采投标文件制作软件') {
        getAction(process.env.VUE_APP_WEBGATEWAY_API + '/tbr/api/bidtools/queryToolList').then((res) => {
          if (res.success) {
            const result = res.result.filter((item) => item.toolName === title)
            if (result.length > 0) {
              window.open(result[0].url + '?attname=' + attachName)
            } else {
              this.$message.warning('未找到该工具下载地址')
            }
          } else {
            this.$message.error(res.message)
          }
        })
        return false
      }
      let downParam = {
        attachGroup: 'group1',
        attachPath: attachPath
      }
      let httpUrl = ''
      if (index == 1) {
        httpUrl = 'https://oss.anhuibidding.com/common/base-platform/rBAAzWVVvuCAd_kCAJNFyeecDH8837.pdf'
      } else if (index == 2) {
        httpUrl = 'https://oss.anhuibidding.com/common/base-platform/rBAAzWVVvpCASVIzAAmOVuM6Rrc269.pdf'
      } else {
        httpUrl = this.downAction
      }
      let filename = attachName
      downFile(httpUrl, downParam).then((data) => {
        if (!data) {
          this.$message.warning('文件下载失败')
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data], { type: 'application/force-download' }), filename)
        } else {
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/force-download' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.notice {
  margin-top: 20px;
  padding-left: 10px;
  padding-right: 10px;

  .one-line {
    line-height: 38px;
  }

  .title:hover {
    color: #1890ff;
    cursor: pointer;
  }

  .down-icon {
    text-align: right;
  }
}
</style>
